/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findNotifications } from '../fn/notification/find-notifications';
import { FindNotifications$Params } from '../fn/notification/find-notifications';
import { ReportDto } from '../models/report-dto';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findNotifications()` */
  static readonly FindNotificationsPath = '/api/notifications';

  /**
   * Returns notifications by year and month
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  findNotifications$Response(params: FindNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
    return findNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns notifications by year and month
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findNotifications(params: FindNotifications$Params, context?: HttpContext): Observable<Array<ReportDto>> {
    return this.findNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportDto>>): Array<ReportDto> => r.body)
    );
  }

}
